import { MSerializers } from "@legacy-megarax/serializers";

export interface CreateTagInput {
  label: string;
}

export const createTagInputSerializer = MSerializers.object<CreateTagInput>({
  label: MSerializers.string,
});
